import React, { useContext, useState, useEffect } from "react";
import AuthContext from "../../store/auth-context";
import { baseUrl } from "../../Config";
import InvoicesTable from "../Table/InvoicesTable";
import { CircularProgress, TextField } from "@mui/material";
import { isNull } from "../../utils/Utils";
import { SendGetRequest } from "../../actions/Actions";
import Color from "../../enum/Color";
import EmailTrackingItemsTable from "./EmailTrackingItemsTable";

const EmailTrackingItems = (props) => {
  const [emailTrackings, setEmailTrackings] = useState([]);
  const [loading, setLoading] = useState(true);

  const authContext = useContext(AuthContext);
  const customer = props.customer;

  const url = baseUrl + "/api/tracking/" + customer.id;

  useEffect(() => {
    setLoading(true);
    SendGetRequest(url, authContext.token, emailTrackingsCallback);
  }, []);

  const emailTrackingsCallback = (data) => {
    setEmailTrackings(data);
    setLoading(false);
  }

  const refreshHandler = () => {
    SendGetRequest(url, authContext.token, emailTrackingsCallback);
  }

  return (
    <div className="InvoicesPage">
      {loading ? <CircularProgress /> :
        <EmailTrackingItemsTable data={emailTrackings}/>
      }
    </div>
  );
};

export default EmailTrackingItems;
